import type { CatalogProduct } from './types';

const ghee = (label: string, image: string) => ({ label, price: null, inStock: true, image });

/**
 * The starter catalog. The site shows it while Firebase is not configured or cannot be reached,
 * and the admin panel's "Add starter products" button copies it into Firestore once.
 * Prices are left empty so a stale copy never shows a wrong price.
 */
export const SEED_PRODUCTS: CatalogProduct[] = [
  {
    id: 'ghee',
    name: 'Pure Ghee',
    nameMl: 'നെയ്യ്',
    category: 'Ghee',
    tag: 'Our ghee',
    description: 'Slow cooked in small batches the way we have since 1994. Golden, grainy and full of aroma.',
    variants: [
      ghee('50 ml', 'ghee-50.webp'),
      ghee('100 ml', 'ghee-100.webp'),
      ghee('200 ml', 'ghee-200.webp'),
      ghee('500 ml', 'ghee-500.webp'),
      ghee('1 L', 'ghee-1000.webp'),
      ghee('2 L', 'ghee-2000.webp'),
    ],
    defaultVariant: '500 ml',
    featured: false,
    active: true,
    sortOrder: 0,
  },
  {
    id: 'dates',
    name: 'Dates',
    nameMl: 'ഈന്തപ്പഴം',
    category: 'Dry fruits',
    tag: 'Our pack',
    description: 'Soft, sticky dates, packed in our own Nimmi’s pouch.',
    variants: [],
    image: 'dates.webp',
    video: 'dates.mp4',
    featured: true,
    active: true,
    sortOrder: 10,
  },
  {
    id: 'almonds',
    name: 'California Almonds',
    nameMl: 'ബദാം',
    category: 'Dry fruits',
    description: 'Almonds from California. Soak a handful overnight for the morning.',
    variants: [],
    art: 'almond',
    featured: true,
    active: true,
    sortOrder: 20,
  },
  {
    id: 'pista',
    name: 'Pista',
    nameMl: 'പിസ്ത',
    category: 'Dry fruits',
    description: 'Lightly crisp pistachios for snacking, sweets and kulfi.',
    variants: [],
    art: 'pista',
    featured: true,
    active: true,
    sortOrder: 30,
  },
  {
    id: 'raisins',
    name: 'Black Raisins',
    nameMl: 'കറുത്ത ഉണക്കമുന്തിരി',
    category: 'Dry fruits',
    description: 'Plump and sweet. Fry them in ghee for payasam.',
    variants: [],
    art: 'raisins',
    featured: true,
    active: true,
    sortOrder: 40,
  },
  {
    id: 'cashew',
    name: 'Cashew JHA',
    nameMl: 'കശുവണ്ടി',
    category: 'Dry fruits',
    description: 'Whole cashews, crisp and buttery. Good with tea, better in payasam.',
    variants: [],
    art: 'cashew',
    featured: true,
    active: true,
    sortOrder: 50,
  },
  {
    id: 'anise',
    name: 'Star Anise',
    nameMl: 'തക്കോലം',
    category: 'Spice',
    description: 'Whole star anise for biriyani and garam masala. A little goes a long way.',
    variants: [],
    art: 'anise',
    featured: true,
    active: true,
    sortOrder: 60,
  },
];
